/**
 * A search hit's excerpt is PostgreSQL `ts_headline` output: the article's indexed text with
 * `<mark>` / `</mark>` around the matches. The text itself is not escaped, so it is never HTML.
 */

/** One run of a search excerpt: plain text, and whether it is a highlighted match. */
export interface ExcerptSegment {
  text: string;
  match: boolean;
}

const MARK_TOKEN = /(<mark>|<\/mark>)/;

/**
 * Splits a `ts_headline` excerpt on its literal `<mark>` / `</mark>` highlight tokens. Everything
 * else — including anything that looks like markup — is text, rendered as a text node, never HTML.
 */
export function excerptSegments(excerpt: string | null | undefined): ExcerptSegment[] {
  const segments: ExcerptSegment[] = [];
  let match = false;
  for (const part of (excerpt ?? "").split(MARK_TOKEN)) {
    if (part === "<mark>") match = true;
    else if (part === "</mark>") match = false;
    else if (part) segments.push({ text: part, match });
  }
  return segments;
}
